class SoundEffect {
  constructor(private readonly audio: HTMLAudioElement) {}

  public play() {
    this.audio.play();
  }

  public static load(filename: string) {
    const audio = new Audio(filename);
    return new SoundEffect(audio);
  }
}

export class SoundEffectsPlayer {
  private cardPlacedSound: SoundEffect;
  private cardFlippedSound: SoundEffect;
  private cardCardsShuffeldSound: SoundEffect;

  constructor() {
    this.cardPlacedSound = SoundEffect.load('/sounds/card-placed.mp3');
    this.cardFlippedSound = SoundEffect.load('/sounds/card-flipped.mp3');
    this.cardCardsShuffeldSound = SoundEffect.load('/sounds/shuffle-cards.mp3');
  }

  public playCardPlaced() {
    this.cardPlacedSound.play();
  }
  public playCardFlipped() {
    this.cardFlippedSound.play();
  }
  public playCardsShuffled() {
    this.cardCardsShuffeldSound.play();
  }
}
